module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/6bacea0285bb005dd1143fd40478d644.svg";